import axios from "axios";
import {
  getAccessToken,
  getRefreshToken,
  setAccessToken,
  clearAuthStorage,
  getOrganizationSettings,
} from "../utils/storage";

// const APPID = process.env.REACT_APP_APPID;
const API_URL = process.env.REACT_APP_API_URL;

const axiosPrivate = axios.create({
  baseURL: API_URL,
});

// Add interceptors
axiosPrivate.interceptors.request.use(
  async (config) => {
    const token = getAccessToken(); // or from context
    if (token) {
      console.log("Access token is: ", token);
      const newOrg = getOrganizationSettings();
      const appid = newOrg.id;


      config.headers["Authorization"] = `Bearer ${token}`;
      config.headers["Accept"] = "application/json";
      config.headers["Content-Type"] = "application/json";
      config.headers["AppID"] = appid;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Refresh token on 401
axiosPrivate.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // clearAuthStorage();
        // window.location.href = "/login";
        const refreshToken = getRefreshToken();
        const res = await axios.post(`${API_URL}/auth/refresh`, {
          refreshToken,
        });
        setAccessToken(res.data.accessToken);

        originalRequest.headers[
          "Authorization"
        ] = `Bearer `;
        return axiosPrivate(originalRequest);
      } catch (refreshErr) {
        // clearAuthStorage();
        // window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default axiosPrivate;
